import React from "react";

export default function FormFieldEditor({ field, onChange }) {
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        onChange(field.id, { [name]: type === "checkbox" ? checked : value });
    };

    return (
        <div className="pt-3">
            {/* Don't show label input for single line separator */}
            {field.type !== "singleline" && (
                <div className="row mb-2">
                    <div className="col-md-6">
                        <label className="form-label">Label</label>
                        <input
                            type="text"
                            name="label"
                            className="form-control"
                            value={field.label}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Width</label>
                        <select
                            name="width"
                            className="form-control"
                            value={field.width}
                            onChange={handleChange}
                        >
                            <option value="full">Full Width</option>
                            <option value="half">Half Width</option>
                            <option value="third">Third Width</option>
                        </select>
                    </div>
                </div>
            )}

            {/* Show placeholder and helper text for input types that support them */}
            {["text", "email", "number", "url", "tel", "whatsapp", "textarea", "numberwithotp"].includes(field.type) && (
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label className="form-label">Placeholder</label>
                        <input
                            type="text"
                            name="placeholder"
                            className="form-control"
                            value={field.placeholder || ""}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-6">
                        <label className="form-label">Helper Text</label>
                        <input
                            type="text"
                            name="helperText"
                            className="form-control"
                            value={field.helperText || ""}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            )}

            {/* Required checkbox for all fields except single line */}
            {field.type !== "singleline" && (
                <div className="form-check ml-2 mb-3">
                    <input
                        type="checkbox"
                        name="required"
                        checked={!!field.required}
                        onChange={handleChange}
                        className="form-check-input"
                        id={`req-${field.id}`}
                    />
                    <label className="form-check-label" htmlFor={`req-${field.id}`}>
                        Required
                    </label>
                </div>
            )}

            {/* Options for select, radio, and multiple choice fields */}
            {(field.type === "select" || field.type === "radio" || field.type === "multiplechoice") && (
                <div className="mb-3">
                    <label className="form-label">Options (comma separated)</label>
                    <input
                        type="text"
                        name="options"
                        className="form-control"
                        value={(field.options || []).join(", ")}
                        onChange={(e) =>
                            onChange(field.id, {
                                options: e.target.value.split(",").map((opt) => opt.trim()),
                            })
                        }
                    />
                    <small className="text-muted">
                        Enter options separated by commas, e.g.: Option 1, Option 2, Option 3
                    </small>
                </div>
            )}

            {/* File type specific settings */}
            {field.type === "file" && (
                <div className="mb-3">
                    <label className="form-label">Allowed File Types</label>
                    <input
                        type="text"
                        name="accept"
                        className="form-control"
                        placeholder=".pdf,.doc,.docx"
                        value={field.accept || ""}
                        onChange={handleChange}
                    />
                    <small className="text-muted">
                        Enter file extensions separated by commas (e.g., .pdf,.doc,.docx)
                    </small>
                </div>
            )}
        </div>
    );
}